module.exports = __webpack_public_path__ + "img/nav-design-sets.adab78a.webp";